import { defineColumnInterface } from "../../lib/defines";
import Component from "./component";

export default defineColumnInterface({
  id: "boolean",
  component: Component,
});
